function Loading({
    bgColor = "bg-slate-200",
    size = 12,
    color = "border-slate-800",
    className = "",
    message = ""
}) {
    const sizeClasses = {
        8: 'w-8 h-8 border-2',
        10: 'w-10 h-10 border-2',
        12: 'w-12 h-12 border-4',
        16: 'w-16 h-16 border-4',
        20: 'w-20 h-20 border-4'
    };

    const spinnerSize = sizeClasses[size] || sizeClasses[12];

    return (
        <div className={`w-full h-full flex flex-col items-center justify-center gap-4 ${bgColor} ${className}`}>
            <div className={`${spinnerSize} rounded-full border-slate-300 border-t-transparent ${color} animate-spin`}></div>

            {message && (
                <p className="text-slate-600 text-sm font-medium">{message}</p>
            )}
        </div>
    );
}

export default Loading;
